import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// iter120 — Eagerly register the offline-aware service worker on app
// boot. Previously this only ran when a user opted into push, which
// meant the runtime cache for customer detail pages, the Warranty
// Policy PDF, and the Help Center never primed for users who skipped
// the push prompt. Register is idempotent (browsers dedupe by URL),
// so calling it here AND inside `usePush` is safe.
if ("serviceWorker" in navigator && process.env.NODE_ENV !== "test") {
  // Defer until after first paint so SW install doesn't compete with
  // critical-path resources.
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {
      /* fail silently — feature degrades gracefully */
    });
  });

  // When a new SW takes control (after a redeploy), reload exactly
  // once so the page picks up the freshly cached static bundles.
  // Without this, users on stale bundles can sit on the old UI
  // because the previously installed SW already served the old
  // ``bundle.js`` from cache before the new SW had a chance to
  // claim the client. Guarded by ``__sw_reloaded__`` to prevent
  // refresh loops.
  let __sw_reloaded__ = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (__sw_reloaded__) return;
    __sw_reloaded__ = true;
    window.location.reload();
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
